// extracted by mini-css-extract-plugin
export default {"base":"mj8dH","comment-1":"PhmUZ","comment-3":"w5vxm","comment-4":"YtE7Y","comment-5":"aDjVu","smallText":"J7djT"};